import { render, staticRenderFns } from "./WindowDescription.vue?vue&type=template&id=bc5090d6&scoped=true"
import script from "./WindowDescription.vue?vue&type=script&lang=ts"
export * from "./WindowDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5090d6",
  null
  
)

export default component.exports